module.exports = __webpack_public_path__ + "img/Firebase-vs-XMPP-Chat-App-Development-1568x1045.c1c8c548.png";